var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { hideMenuProvider } from '../../utilities/picker.tools';
import { pairLessOrEqual } from '../shared/comparators';
import { monthHoverStateMapper, monthRangeMapper, yearRangeMapper } from '../shared/mapper-utils';
import { getYear } from '../shared/utils';
import { displayMonthDate, monthDateToKey, monthKeyToDate } from './month-picker-calculations';
import '../shared/calendar/sds-calendar.lit';
import styles from '../sds-date-picker.lit.scss';
import { isNil } from 'lodash-es';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-month-range` is a web component that enables users to select a range of months,
 * providing an intuitive interface for navigating through months and years.
 * It is particularly useful for scenarios such as filtering data by date range,
 * setting deadlines, or scheduling events that span multiple months.
 *
 * ### Features:
 * - **Month Range Selection**: Users can select a start month and an end month,
 *   making it easy to define a range for various applications.
 * - **Locale Support**: The component formats month names according to the user's locale.
 * - **Events**: Emits events to notify parent components of changes in selection.
 */
let SdsMonthRange = (() => {
    var _SdsMonthRange_placeholder_accessor_storage, _SdsMonthRange_currentMonth_accessor_storage, _SdsMonthRange_startMonth_accessor_storage, _SdsMonthRange_endMonth_accessor_storage, _SdsMonthRange_hint_accessor_storage, _SdsMonthRange_disabled_accessor_storage, _SdsMonthRange_invalid_accessor_storage, _SdsMonthRange_errorMessage_accessor_storage, _SdsMonthRange__contextMenu_accessor_storage, _SdsMonthRange__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-month-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _currentMonth_decorators;
    let _currentMonth_initializers = [];
    let _currentMonth_extraInitializers = [];
    let _startMonth_decorators;
    let _startMonth_initializers = [];
    let _startMonth_extraInitializers = [];
    let _endMonth_decorators;
    let _endMonth_initializers = [];
    let _endMonth_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsMonthRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsMonthRange_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.month_picker_range.placeholder'));
            _SdsMonthRange_currentMonth_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _currentMonth_initializers, void 0)));
            _SdsMonthRange_startMonth_accessor_storage.set(this, (__runInitializers(this, _currentMonth_extraInitializers), __runInitializers(this, _startMonth_initializers, void 0)));
            _SdsMonthRange_endMonth_accessor_storage.set(this, (__runInitializers(this, _startMonth_extraInitializers), __runInitializers(this, _endMonth_initializers, void 0)));
            _SdsMonthRange_hint_accessor_storage.set(this, (__runInitializers(this, _endMonth_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsMonthRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsMonthRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsMonthRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsMonthRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsMonthRange__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerMonthPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.mouseOutHandler = () => {
                if (this.endMonth === undefined) {
                    this._sdsInnerMonthPicker.setMonthStateMapper(monthRangeMapper(this.startMonth, undefined));
                }
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateValue();
                this.updatePageIndex();
            };
            this.handleHover = (event) => {
                if (this.startMonth !== undefined &&
                    this.endMonth === undefined &&
                    event.detail.month !== undefined) {
                    this._sdsInnerMonthPicker.setMonthStateMapper(monthHoverStateMapper(this.startMonth, event.detail.month));
                }
                else if (event.detail.month === undefined) {
                    this.setMappers();
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
            this.handleMonthPicked = (event) => {
                this.updateSelectedMonth([event.detail.year, event.detail.month]);
            };
            this.handleYearChanged = (event) => {
                if (isNil(this.startMonth) || !(isNil(this.startMonth) || isNil(this.endMonth))) {
                    this._preselectedStartYear = event.detail.year;
                    this._preselectedEndYear = undefined;
                }
                else {
                    this._preselectedEndYear = event.detail.year;
                }
                this.setMappers();
            };
        }
        /**
         * Sets the placeholder text for the month range input, providing a hint to users when no month range is selected.
         * This helps guide users to understand the expected input or purpose of the month range selection.
         *
         * This attribute improves accessibility and user experience by indicating what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the month range input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsMonthRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsMonthRange_placeholder_accessor_storage, value, "f"); }
        /**
         * Represents the current month displayed in the month range picker.
         * It is formatted as `{year}/{month}`, allowing the component to maintain context for the month selection.
         *
         * This attribute is essential for initializing the component with the current month and
         * helps users quickly navigate to the relevant range of months.
         *
         * @attr {string} current-month - The current month in `{year}/{month}` format.
         */
        get currentMonth() { return __classPrivateFieldGet(this, _SdsMonthRange_currentMonth_accessor_storage, "f"); }
        set currentMonth(value) { __classPrivateFieldSet(this, _SdsMonthRange_currentMonth_accessor_storage, value, "f"); }
        /**
         * Defines the starting month of the selected range.
         * This attribute is converted from a month key to a `LocalMonth` object using the `monthKeyToDate` converter.
         *
         * The value can be either a `LocalMonth` object or `undefined` if no start month is selected.
         *
         * When this attribute is set, it will automatically update the UI to reflect the selected start month.
         *
         * @attr {LocalMonth} start-month - The starting month of the selected range.
         */
        get startMonth() { return __classPrivateFieldGet(this, _SdsMonthRange_startMonth_accessor_storage, "f"); }
        set startMonth(value) { __classPrivateFieldSet(this, _SdsMonthRange_startMonth_accessor_storage, value, "f"); }
        /**
         * Defines the ending month of the selected range.
         * This attribute is converted from a month key to a `LocalMonth` object using the `monthKeyToDate` converter.
         *
         * The value can be either a `LocalMonth` object or `undefined` if no end month is selected.
         *
         * When this attribute is set, it will automatically update the UI to reflect the selected end month.
         *
         * @attr {LocalMonth} end-month - The ending month of the selected range.
         */
        get endMonth() { return __classPrivateFieldGet(this, _SdsMonthRange_endMonth_accessor_storage, "f"); }
        set endMonth(value) { __classPrivateFieldSet(this, _SdsMonthRange_endMonth_accessor_storage, value, "f"); }
        /**
         * Hint for this month range.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsMonthRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsMonthRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this month range is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsMonthRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsMonthRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this month range is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsMonthRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsMonthRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this month range, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsMonthRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsMonthRange_errorMessage_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsMonthRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsMonthRange__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsMonthRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsMonthRange__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-inner-month-picker
                    id="sds-inner-month-picker"
                    currentMonth="${this.currentMonth}"
                    @mouseout="${this.mouseOutHandler}"
                    @sds.inner-month-picker.hovered="${this.handleHover}"
                    @sds.inner-month-picker.changed="${this.handleMonthPicked}"
                    @sds.inner-month-picker.year-changed="${this.handleYearChanged}"
                >
                </sds-inner-month-picker>
            </sds-context-menu>
        `;
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('startMonth') || _changedProperties.has('endMonth')) {
                this.setMappers();
            }
            if (_changedProperties.has('endMonth') && this.endMonth !== undefined) {
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('startMonth') || _changedProperties.has('endMonth')) {
                this.updateInput();
            }
        }
        setMappers() {
            var _a, _b, _c;
            const startYear = (_a = this._preselectedStartYear) !== null && _a !== void 0 ? _a : getYear(this.startMonth);
            let endYear;
            if (!isNil(this.endMonth) && isNil(this._preselectedStartYear)) {
                // case when endMonth is set by user
                endYear = getYear(this.endMonth);
            }
            else {
                endYear = this._preselectedEndYear;
            }
            (_b = this._sdsInnerMonthPicker) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(yearRangeMapper(startYear, endYear));
            (_c = this._sdsInnerMonthPicker) === null || _c === void 0 ? void 0 : _c.setMonthStateMapper(monthRangeMapper(this.startMonth, this.endMonth));
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        updatePageIndex() {
            var _a, _b;
            if (this.startMonth) {
                (_a = this._sdsInnerMonthPicker) === null || _a === void 0 ? void 0 : _a.updatePageIndex(this.startMonth[0]);
            }
            else if (this.currentMonth) {
                (_b = this._sdsInnerMonthPicker) === null || _b === void 0 ? void 0 : _b.updatePageIndex(monthKeyToDate(this.currentMonth)[0]);
            }
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerMonthPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#sds-inner-month-picker');
            if (sdsInnerMonthPicker) {
                this._sdsInnerMonthPicker = sdsInnerMonthPicker;
            }
        }
        resetPage() {
            this._sdsInnerMonthPicker.navigateTo('SelectMonth');
            this.updatePageIndex();
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        resetPreselectedYears() {
            this._preselectedStartYear = undefined;
            this._preselectedEndYear = undefined;
            this.setMappers();
        }
        updateSelectedMonth(month) {
            this.updateValue(month);
            this.updateInput();
        }
        updateValue(month) {
            if (!month) {
                this.startMonth = undefined;
                this.endMonth = undefined;
                this.dispatchChange();
            }
            else if (this.startMonth === undefined || this.endMonth !== undefined) {
                this.startMonth = month;
                this.endMonth = undefined;
            }
            else {
                this.endMonth = month;
                if (pairLessOrEqual(this.endMonth, this.startMonth)) {
                    [this.startMonth, this.endMonth] = [this.endMonth, this.startMonth];
                }
                this.hideContextMenu();
                this.resetPreselectedYears();
                this.dispatchChange();
            }
        }
        updateInput() {
            let inputValue = '';
            if (this.startMonth) {
                inputValue = displayMonthDate(this.startMonth);
            }
            if (this.endMonth) {
                inputValue += ' - ' + displayMonthDate(this.endMonth);
            }
            this._inputDate.value = inputValue;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsMonthRange.MONTH_RANGE_CHANGE_EVENT, {
                detail: {
                    startMonth: this.startMonth ? monthDateToKey(...this.startMonth) : undefined,
                    endMonth: this.endMonth ? monthDateToKey(...this.endMonth) : undefined,
                },
            }));
        }
    };
    _SdsMonthRange_placeholder_accessor_storage = new WeakMap();
    _SdsMonthRange_currentMonth_accessor_storage = new WeakMap();
    _SdsMonthRange_startMonth_accessor_storage = new WeakMap();
    _SdsMonthRange_endMonth_accessor_storage = new WeakMap();
    _SdsMonthRange_hint_accessor_storage = new WeakMap();
    _SdsMonthRange_disabled_accessor_storage = new WeakMap();
    _SdsMonthRange_invalid_accessor_storage = new WeakMap();
    _SdsMonthRange_errorMessage_accessor_storage = new WeakMap();
    _SdsMonthRange__contextMenu_accessor_storage = new WeakMap();
    _SdsMonthRange__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsMonthRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _currentMonth_decorators = [property({ attribute: 'current-month' })];
        _startMonth_decorators = [property({
                type: String,
                converter: monthKeyToDate,
                attribute: 'start-month',
            })];
        _endMonth_decorators = [property({
                type: String,
                converter: monthKeyToDate,
                attribute: 'end-month',
            })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _currentMonth_decorators, { kind: "accessor", name: "currentMonth", static: false, private: false, access: { has: obj => "currentMonth" in obj, get: obj => obj.currentMonth, set: (obj, value) => { obj.currentMonth = value; } }, metadata: _metadata }, _currentMonth_initializers, _currentMonth_extraInitializers);
        __esDecorate(_classThis, null, _startMonth_decorators, { kind: "accessor", name: "startMonth", static: false, private: false, access: { has: obj => "startMonth" in obj, get: obj => obj.startMonth, set: (obj, value) => { obj.startMonth = value; } }, metadata: _metadata }, _startMonth_initializers, _startMonth_extraInitializers);
        __esDecorate(_classThis, null, _endMonth_decorators, { kind: "accessor", name: "endMonth", static: false, private: false, access: { has: obj => "endMonth" in obj, get: obj => obj.endMonth, set: (obj, value) => { obj.endMonth = value; } }, metadata: _metadata }, _endMonth_initializers, _endMonth_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsMonthRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.MONTH_RANGE_CHANGE_EVENT = 'sds.month-range.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsMonthRange = _classThis;
})();
export { SdsMonthRange };
